/* unplugin-vue-components disabled */import script from "./LoginView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginView.vue?vue&type=script&setup=true&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=585b77c0&lang=scss"

const __exports__ = script;

export default __exports__